import { render, staticRenderFns } from "./SysSettingMgt.vue?vue&type=template&id=70b880ec&scoped=true"
import script from "./SysSettingMgt.vue?vue&type=script&lang=js"
export * from "./SysSettingMgt.vue?vue&type=script&lang=js"
import style0 from "./SysSettingMgt.vue?vue&type=style&index=0&id=70b880ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b880ec",
  null
  
)

export default component.exports